import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Error } from '@/components/templates/Error.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { useTrackFormError } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'

const ErrorScreen = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'errorScreen',
  })
  const navigate = useNavigate()

  const { error, resetStore } = useAppointmentStore()
  useTrackFormError({ error: t(`messages.${error}`) })

  return (
    <ScreenWrapper>
      <Error
        error={error}
        onReset={() => {
          resetStore()
          navigate('/')
        }}
        onBack={() => navigate(-1)}
      />
    </ScreenWrapper>
  )
}

export { ErrorScreen }
